export default "__VITE_ASSET__87b45034__"